import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useRouteMatch, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import {
  getProductUrlToken,
  setPDPCurrent
} from '../../../store/products/actions';
import { normalizeError } from '../../../store/exception/utils';
import { STATUS } from '../../../constants/commonConstants';
import RenderException from '../../common/Exception/RenderException';
import PDPContainer from '../pdp';
import AssetLandingPage from '../alp';
import ProductSkeletonLoader from './ProductSkeletonLoader';

const Product = () => {
  // if the productId is given in the URL explicitly, just use that. Will always be PDP.
  const { productId } = queryString.parse(window.location.search);
  const { partNumber } = useParams();
  const { isExact } = useRouteMatch();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const error = useSelector(s => s.products.getProductUrlTokenError);
  const status = useSelector(s => s.products.getProductUrlTokenStatus);
  const current = useSelector(s => s.products.current);
  const byId = useSelector(s => s.products.byId);
  const currentProduct = byId[current] || {};

  useEffect(() => {
    if (productId) {
      // TODO: Verify that productId won't be in query strong on MLP
      dispatch(setPDPCurrent(productId));
    } else if (!isExact) {
      /**
       * 202190: We are using isExact from useRouteMatch hook because there is an issue
       * when there are one or more subcatogories for a part.
       * If this is the case, we are passing the partNumber from the url and
       * not the partNumber from the useParams hook.
       */
      const urlArrayElements = pathname.split('/');
      const lastElementIndex = urlArrayElements.length - 1;
      const urlPartNumber = urlArrayElements[lastElementIndex];
      dispatch(getProductUrlToken(decodeURIComponent(urlPartNumber)));
    } else if (partNumber) {
      dispatch(getProductUrlToken(decodeURIComponent(partNumber))); //the decodeURIComponent function is used to avoid the part number from being encoded 2 times
    } else {
      // TODO: this shouldn't happen, but if it does we should throw a generic error
      //       maybe we can set getProductUrlTokenStatus to REJECTED?
    }
  }, [dispatch, isExact, partNumber, pathname, productId]);

  if (status === STATUS.PENDING || (!current && status === STATUS.IDLE)) {
    return <ProductSkeletonLoader />;
  }
  if (status === STATUS.REJECTED) {
    throw new RenderException(normalizeError(error));
  }
  return currentProduct.isMLP ? <AssetLandingPage /> : <PDPContainer />;
};

export default Product;
